<template>
  <div class="l-container TutorsIndex2">

    <div class="pager"><i class="fa fa-arrow-left" @click="prev"></i><span class="nowIndex">{{nowIndex + 1}}</span><i class="fa fa-arrow-right" @click="next"></i></div>

    <template v-if="user.type === 'admin' || user.type === 'owner' || user.type === 'act' || user.type === 'mgr'">
      <export-modal class="export-modal" :obj="obj" :columns="columns" @swi="switchV" @res="reset" @all="all" @def="def">Export</export-modal>
    </template>

    現在表示数 : {{max}}
    <i class="fa fa-sort-alpha-desc"></i>ソート<i class="fa fa-fw fa-angle-down"></i>
    <span v-for="(list, index) in columns" :key="index">
      <template v-if="sortColumn === columns[index].code">
        {{ list.name }} : {{sortState}}
      </template>
    </span>

    <h1 class="m-label m-label-custom" @click="switchColumns('columnsFlg')" v-bind:class="{ 'slideActive': columnsFlg }" v-ripple>項目</h1>

    <template v-if="columnsFlg">
      <div style="display: flex; flex-wrap: wrap">
        <btn class="m-btn--column" @click.native="reset()">RESET</btn>
        <btn class="m-btn--column" @click.native="all()">ALL</btn>
        <btn class="m-btn--column" @click.native="def()">DEFAULT</btn>

        <btn v-for="(list, index) in columns" :key="index" class="m-btn--column" @click.native="switchV(index)" v-bind:class="{ 'active': columns[index].show }">{{ list.name }}</btn>

      </div>
    </template>

    <btn class="resetSearch" @click.native="resetSearch">Reset</btn>

    <div class="index-box" @scroll="offset">
      <table-c>

        <tr-c slot="tr-th">
          <td-c class="sticky-1"></td-c>
          <template v-if="columns[0].show">
            <td-c class="sticky-1">
              <input v-model="search.id" type="text" @keyup="searchTable()" placeholder="検索">
            </td-c>
          </template>
          <template v-if="columns[1].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.office_id" :options="offices" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[2].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.user_id" :options="users" label="user" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[3].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.state" :options="state" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[4].show">
            <td-c class="sticky-1">
              <input type="text" v-model="search.registration_date[0]" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[5].show">
            <td-c class="sticky-1">
              <input type="text" v-model="search.name" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[6].show">
            <td-c class="sticky-1">
              <input type="text" v-model="search.kana" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[7].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.gender" :options="gender" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[8].show">
            <td-c class="sticky-1">
              <input type="text" v-model="search.birthday" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[9].show">
            <td-c class="sticky-1">
              <input type="text" v-model="search.age[0]" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[10].show">
            <td-c class="sticky-1">
              <input type="text" v-model="search.age[1]" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[11].show">
            <td-c class="sticky-1">
              <input type="text" v-model="search.zip" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[12].show">
            <td-c class="select sticky-1">
              <multiselect v-model="watch.pref" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="id" :options="prefs" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[13].show">
            <td-c class="sticky-1">
              <input type="text" v-model="search.address" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[14].show">
            <td-c class="sticky-1">
              <input type="text" v-model="search.tel1" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[15].show">
            <td-c class="sticky-1">
              <input type="text" v-model="search.tel2" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[16].show">
            <td-c class="sticky-1">
              <input type="text" v-model="search.mail1" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[17].show">
            <td-c class="sticky-1">
              <input type="text" v-model="search.mail2" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[18].show">
            <td-c class="sticky-1">
              <input type="text" v-model="search.home_zip" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[19].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.home_pref" :options="prefs" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[20].show">
            <td-c class="sticky-1">
              <input type="text" v-model="search.home_address" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[21].show">
            <td-c class="sticky-1">
              <input type="text" v-model="search.home_tel" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[22].show">
            <td-c class="sticky-1">
              <input type="text" v-model="search.school_name" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[23].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.school_stage" :options="school_stage" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[24].show">
            <td-c class="sticky-1">
              <input type="text" v-model="search.department" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[25].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.old_grade" :options="old_grade" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[26].show">
            <td-c class="select sticky-1">
              <!-- 今検索できない -->
              <multiselect @select="searchTable()" v-model="watch.grade" :options="grade" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[27].show">
            <td-c class="sticky-1">
              <input type="text" v-model="search.grade_flag" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[28].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.department_type" :options="department_type" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[29].show">
            <td-c class="sticky-1">
              <input type="text" v-model="search.club" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[30].show">
            <td-c class="sticky-1">
              <input type="text" v-model="search.high_school_name" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[31].show">
            <td-c class="sticky-1">
              <input type="text" v-model="search.high_school_club" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[32].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.transportation_car" :options="marubatu" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[33].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.transportation_bike" :options="marubatu" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[34].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.transportation_scooters" :options="marubatu" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[35].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.transportation_bicycle" :options="marubatu" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[36].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.transportation_train" :options="marubatu" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[37].show">
            <td-c class="sticky-1">
              <input type="text" v-model="search.nearest_station" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[38].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.exam_s" :options="yesno" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[39].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.exam_c" :options="yesno" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[40].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.exam_k" :options="yesno" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[41].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.exam_d" :options="yesno" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[42].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.experience_tutor" :options="yesno" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[43].show">
            <td-c class="sticky-1">
              <input type="text" v-model="search.experience_tutor_note" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[44].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.experience_cram" :options="yesno" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[45].show">
            <td-c class="sticky-1">
              <input type="text" v-model="search.experience_cram_note" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[46].show">
            <td-c class="sticky-1">
              <input type="text" v-model="search.channel_id" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[47].show">
            <td-c class="sticky-1">
              <input type="text" v-model="search.medium_note" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[48].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.published" :options="possible" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[49].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.information" :options="possible" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[50].show">
            <td-c class="sticky-1">
              <input type="text" v-model="search.impression" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[51].show">
            <td-c class="sticky-1">
              <input type="text" v-model="search.impression_note" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[52].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.training" :options="training" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[53].show">
            <td-c class="sticky-1">
              <input type="text" v-model="search.training_note" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[54].show">
            <td-c class="select sticky-1">
              <multiselect @select="searchTable()" v-model="watch.ssk" :options="ssk" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[55].show">
            <td-c class="sticky-1">
              <input type="text" v-model="search.created_at" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[56].show">
            <td-c class="sticky-1">
              <input type="text" v-model="search.updated_at" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[57].show">
            <td-c class="sticky-1">
              <input type="text" v-model="search.note" @keyup="searchTable()">
            </td-c>
          </template>
        </tr-c>

        <tr-c slot="tr-th">
          <td-c class="sticky-2"></td-c>
          <template v-if="columns[0].show"><td-c class="sticky-2"><input v-model="search.not_id" type="text" @keyup="searchTable()" placeholder="除外検索"></td-c></template>
          <template v-if="columns[1].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_office_id" :options="offices" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[2].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_user_id" :options="users" label="user" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[3].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_state" :options="state" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[4].show">
            <td-c class="sticky-2">
              <input type="text" v-model="search.not_registration_date[0]" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[5].show">
            <td-c class="sticky-2">
              <input type="text" v-model="search.not_name" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[6].show">
            <td-c class="sticky-2">
              <input type="text" v-model="search.not_kana" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[7].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_gender" :options="gender" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[8].show">
            <td-c class="sticky-2">
              <input type="text" v-model="search.not_birthday" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[9].show">
            <td-c class="sticky-2">
              <input type="text" v-model="search.not_age[0]" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[10].show">
            <td-c class="sticky-2">
              <input type="text" v-model="search.not_age[1]" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[11].show">
            <td-c class="sticky-2">
              <input type="text" v-model="search.not_zip" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[12].show">
            <td-c class="select sticky-2">
              <multiselect v-model="watch.not_pref" tag-placeholder="Add this as new tag" placeholder="" label="name" track-by="id" :options="prefs" :multiple="true" :taggable="true" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[13].show">
            <td-c class="sticky-2">
              <input type="text" v-model="search.not_address" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[14].show">
            <td-c class="sticky-2">
              <input type="text" v-model="search.not_tel1" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[15].show">
            <td-c class="sticky-2">
              <input type="text" v-model="search.not_tel2" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[16].show">
            <td-c class="sticky-2">
              <input type="text" v-model="search.not_mail1" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[17].show">
            <td-c class="sticky-2">
              <input type="text" v-model="search.not_mail2" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[18].show">
            <td-c class="sticky-2">
              <input type="text" v-model="search.not_home_zip" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[19].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_home_pref" :options="prefs" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[20].show">
            <td-c class="sticky-2">
              <input type="text" v-model="search.not_home_address" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[21].show">
            <td-c class="sticky-2">
              <input type="text" v-model="search.not_home_tel" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[22].show">
            <td-c class="sticky-2">
              <input type="text" v-model="search.not_school_name" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[23].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_school_stage" :options="school_stage" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[24].show">
            <td-c class="sticky-2">
              <input type="text" v-model="search.not_department" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[25].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_old_grade" :options="old_grade" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[26].show">
            <td-c class="select sticky-2">
              <!-- 今検索できない -->
              <multiselect @select="searchTable()" v-model="watch.not_grade" :options="grade" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[27].show">
            <td-c class="sticky-2">
              <input type="text" v-model="search.not_grade_flag" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[28].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_department_type" :options="department_type" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[29].show">
            <td-c class="sticky-2">
              <input type="text" v-model="search.not_club" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[30].show">
            <td-c class="sticky-2">
              <input type="text" v-model="search.not_high_school_name" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[31].show">
            <td-c class="sticky-2">
              <input type="text" v-model="search.not_high_school_club" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[32].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_transportation_car" :options="marubatu" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[33].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_transportation_bike" :options="marubatu" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[34].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_transportation_scooters" :options="marubatu" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[35].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_transportation_bicycle" :options="marubatu" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[36].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_transportation_train" :options="marubatu" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[37].show">
            <td-c class="sticky-2">
              <input type="text" v-model="search.not_nearest_station" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[38].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_exam_s" :options="yesno" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[39].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_exam_c" :options="yesno" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[40].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_exam_k" :options="yesno" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[41].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_exam_d" :options="yesno" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[42].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_experience_tutor" :options="yesno" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[43].show">
            <td-c class="sticky-2">
              <input type="text" v-model="search.not_experience_tutor_note" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[44].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_experience_cram" :options="yesno" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[45].show">
            <td-c class="sticky-2">
              <input type="text" v-model="search.not_experience_cram_note" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[46].show">
            <td-c class="sticky-2">
              <input type="text" v-model="search.not_channel_id" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[47].show">
            <td-c class="sticky-2">
              <input type="text" v-model="search.not_medium_note" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[48].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_published" :options="possible" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[49].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_information" :options="possible" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[50].show">
            <td-c class="sticky-2">
              <input type="text" v-model="search.not_impression" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[51].show">
            <td-c class="sticky-2">
              <input type="text" v-model="search.not_impression_note" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[52].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_training" :options="training" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[53].show">
            <td-c class="sticky-2">
              <input type="text" v-model="search.not_training_note" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[54].show">
            <td-c class="select sticky-2">
              <multiselect @select="searchTable()" v-model="watch.not_ssk" :options="ssk" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="columns[55].show">
            <td-c class="sticky-2">
              <input type="text" v-model="search.not_created_at" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[56].show">
            <td-c class="sticky-2">
              <input type="text" v-model="search.not_updated_at" @keyup="searchTable()">
            </td-c>
          </template>
          <template v-if="columns[57].show">
            <td-c class="sticky-2">
              <input type="text" v-model="search.not_note" @keyup="searchTable()">
            </td-c>
          </template>
        </tr-c>

        <tr-c slot="tr-th">
          <th-c>№</th-c>
          <th-c v-for="(list, index) in columns" :key="index" v-if="columns[index].show" class="sticky-3" @click.native='sort(columns[index].code)'>{{ list.name }}</th-c>
        </tr-c>

        <tr-c @click.native='linkTutor(list, index)' slot="tr-td" v-for="(list, index) in mapTutors" :key="list.id" class="tr_hover" v-bind:class="{ 'now': nowIndex === index }">
          <td-c>{{index + 1}}</td-c>
          <template v-if="columns[0].show"><td-c>{{list.id}}</td-c></template>
          <template v-if="columns[1].show"><td-c>{{list.mapOffice}}</td-c></template>
          <template v-if="columns[2].show">
            <template v-if="list.user">
              <td-c>{{list.user.user}}</td-c>
            </template>
            <template v-else>
              <td-c></td-c>
            </template>
          </template>
          <template v-if="columns[3].show"><td-c>{{list.mapState}}</td-c></template>
          <template v-if="columns[4].show"><td-c>{{list.registration_date}}</td-c></template>
          <template v-if="columns[5].show"><td-c v-bind:class="[{ 'men': list.gender === 1 }, { 'women': list.gender === 2 }]">{{list.f_name}} {{list.l_name}}</td-c></template>
          <template v-if="columns[6].show"><td-c v-bind:class="[{ 'men': list.gender === 1 }, { 'women': list.gender === 2 }]">{{list.f_name_kana}} {{list.l_name_kana}}</td-c></template>
          <template v-if="columns[7].show"><td-c>{{list.mapGender}}</td-c></template>
          <template v-if="columns[8].show"><td-c>{{list.birthday}}</td-c></template>
          <template v-if="columns[9].show"><td-c>{{list.age}}</td-c></template>
          <template v-if="columns[10].show"><td-c></td-c></template>
          <template v-if="columns[11].show"><td-c>{{list.zip}}</td-c></template>
          <template v-if="columns[12].show"><td-c>{{list.mapPref}}</td-c></template>
          <template v-if="columns[13].show"><td-c>{{list.address1}} {{list.address2}}</td-c></template>
          <template v-if="columns[14].show"><td-c><a :href="`tel: ${list.tel1}`">{{list.tel1}}</a></td-c></template>
          <template v-if="columns[15].show"><td-c><a :href="`tel: ${list.tel2}`">{{list.tel2}}</a></td-c></template>
          <template v-if="columns[16].show"><td-c><a :href="`mailto: ${list.mail1}`">{{list.mail1}}</a></td-c></template>
          <template v-if="columns[17].show"><td-c><a :href="`mailto: ${list.mail2}`">{{list.mail2}}</a></td-c></template>
          <template v-if="columns[18].show"><td-c>{{list.home_zip}}</td-c></template>
          <template v-if="columns[19].show"><td-c>{{list.mapHomePref}}</td-c></template>
          <template v-if="columns[20].show"><td-c>{{list.home_address}}</td-c></template>
          <template v-if="columns[21].show"><td-c>{{list.home_tel}}</td-c></template>
          <template v-if="columns[22].show"><td-c>{{list.school_name}}</td-c></template>
          <template v-if="columns[23].show"><td-c>{{list.mapSchoolStage}}</td-c></template>
          <template v-if="columns[24].show"><td-c>{{list.department}}</td-c></template>
          <template v-if="columns[25].show"><td-c>{{list.mapOldGrade}}</td-c></template>
          <template v-if="columns[26].show"><td-c>{{list.grade}}</td-c></template>
          <template v-if="columns[27].show"><td-c>{{list.grade_flag}}</td-c></template>
          <template v-if="columns[28].show"><td-c>{{list.mapDepartmentType}}</td-c></template>
          <template v-if="columns[29].show"><td-c>{{list.club}}</td-c></template>
          <template v-if="columns[30].show"><td-c>{{list.high_school_name}}</td-c></template>
          <template v-if="columns[31].show"><td-c>{{list.high_school_club}}</td-c></template>
          <template v-if="columns[32].show"><td-c>{{list.mapCar}}</td-c></template>
          <template v-if="columns[33].show"><td-c>{{list.mapBike}}</td-c></template>
          <template v-if="columns[34].show"><td-c>{{list.mapScooters}}</td-c></template>
          <template v-if="columns[35].show"><td-c>{{list.mapBicycle}}</td-c></template>
          <template v-if="columns[36].show"><td-c>{{list.mapTrain}}</td-c></template>
          <template v-if="columns[37].show"><td-c>{{list.nearest_station}}</td-c></template>
          <template v-if="columns[38].show"><td-c>{{list.mapExamS}}</td-c></template>
          <template v-if="columns[39].show"><td-c>{{list.mapExamC}}</td-c></template>
          <template v-if="columns[40].show"><td-c>{{list.mapExamK}}</td-c></template>
          <template v-if="columns[41].show"><td-c>{{list.mapExamD}}</td-c></template>
          <template v-if="columns[42].show"><td-c>{{list.mapExperienceTutor}}</td-c></template>
          <template v-if="columns[43].show"><td-c>{{list.experience_tutor_note}}</td-c></template>
          <template v-if="columns[44].show"><td-c>{{list.mapExperienceCram}}</td-c></template>
          <template v-if="columns[45].show"><td-c>{{list.experience_cram_note}}</td-c></template>
          <template v-if="columns[46].show"><td-c>{{list.channel_id}}</td-c></template>
          <template v-if="columns[47].show"><td-c>{{list.medium_note}}</td-c></template>
          <template v-if="columns[48].show"><td-c>{{list.mapPublished}}</td-c></template>
          <template v-if="columns[49].show"><td-c>{{list.mapInformation}}</td-c></template>
          <template v-if="columns[50].show"><td-c>{{list.mapImpression}}</td-c></template>
          <template v-if="columns[51].show"><td-c>{{list.impression_note}}</td-c></template>
          <template v-if="columns[52].show"><td-c>{{list.mapTraining}}</td-c></template>
          <template v-if="columns[53].show"><td-c>{{list.training_note}}</td-c></template>
          <template v-if="columns[54].show"><td-c>{{list.mapSsk}}</td-c></template>
          <template v-if="columns[55].show"><td-c>{{list.created_at}}</td-c></template>
          <template v-if="columns[56].show"><td-c>{{list.updated_at}}</td-c></template>
          <template v-if="columns[57].show"><td-c>{{list.note}}</td-c></template>
        </tr-c>

      </table-c>
    </div>
  </div>

</template>

<script>
// let startLatLng = [35.712408, 139.776188] // 上野駅
// let targetLatLng = [35.710552, 139.777074] // LIG
// let goalMarkerImg = 'https://82mou.github.io/src/images/marker-on-dummy.png'
// let map
//
// function initialize () {
//   let options = {
//     zoom: 16,
//     center: new google.maps.LatLng(startLatLng[0], startLatLng[1]),
//     mapTypeId: google.maps.MapTypeId.ROADMAP
//   }
//   map = new google.maps.Map(document.getElementById('map_canvas'), options)
//   let rendererOptions = {
//     map: map, // 描画先の地図
//     draggable: true, // ドラッグ可
//     preserveViewport: true // centerの座標、ズームレベルで表示
//   }
//   let directionsDisplay = new google.maps.DirectionsRenderer(rendererOptions)
//   let directionsService = new google.maps.DirectionsService()
//   directionsDisplay.setMap(map)
//   let request = {
//     origin: new google.maps.LatLng(startLatLng[0], startLatLng[1]), // スタート地点
//     destination: new google.maps.LatLng(targetLatLng[0], targetLatLng[1]), // ゴール地点
//     travelMode: google.maps.DirectionsTravelMode.WALKING // 移動手段
//   }
//   directionsService.route(request, function (response, status) {
//     if (status === google.maps.DirectionsStatus.OK) {
//       new google.maps.DirectionsRenderer({
//         map: map,
//         directions: response,
//         suppressMarkers: true // デフォルトのマーカーを削除
//       })
//       let leg = response.routes[0].legs[0]
//       makeMarker(leg.end_location, markers.goalMarker, map)
//       setTimeout(function () {
//         map.setZoom(16) // ルート表示後にズーム率を変更
//       })
//     }
//   })
// }
//
// function makeMarker (position, icon, map) {
//   let marker = new google.maps.Marker({
//     position: position,
//     map: map,
//     icon: icon
//   })
// }
//
// let markers = {
//   goalMarker: new google.maps.MarkerImage(
//     goalMarkerImg, // 画像のパス
//     new google.maps.Size(24, 33), // マーカーのwidth,height
//     new google.maps.Point(0, 0), // 画像データの中で、どの部分を起点として表示させるか
//     new google.maps.Point(12, 33), // マーカーのpositionで与えられる緯度経度を画像のどの点にするか
//     new google.maps.Size(24, 33)) // 画像の大きさを拡大縮小
// }
//
// initialize()
import { getAPIURL } from '@/store/getters.js'
import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/tutors/search?limit=' + config.LIMIT

var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  offset: config.LIMIT,
  max: config.LIMIT + 1,
  url: url,
  searchUrl: url,
  exportUrl: url,
  pageName: 'tutor',
  pageNames: 'tutors'
}

let _ = window._
export default {
  directives: {
    focus: {
      inserted (el, binding) {
        el.focus()
        // console.log(el)
        // console.log(binding)
      }
    }
  },

  props: {
    routeName: Object
  },

  data () {
    return {
      sortState: '降順',
      sortColumn: 'registration_date',

      columnsFlg: false,

      index: 0,
      nowIndex: 0,

      // getGeo用
      pref: [
        { name: '未選択', value: 0 },
        { name: '北海道', value: 1 },
        { name: '青森県', value: 2 },
        { name: '秋田県', value: 3 },
        { name: '岩手県', value: 4 },
        { name: '山形県', value: 5 },
        { name: '宮城県', value: 6 },
        { name: '福島県', value: 7 },
        { name: '栃木県', value: 8 },
        { name: '山梨県', value: 9 },
        { name: '群馬県', value: 10 },
        { name: '茨城県', value: 11 },
        { name: '千葉県', value: 12 },
        { name: '埼玉県', value: 13 },
        { name: '東京都', value: 14 },
        { name: '神奈川県', value: 15 },
        { name: '静岡県', value: 16 },
        { name: '長野県', value: 17 },
        { name: '愛知県', value: 18 },
        { name: '岐阜県', value: 19 },
        { name: '新潟県', value: 20 },
        { name: '富山県', value: 21 },
        { name: '石川県', value: 22 },
        { name: '福井県', value: 23 },
        { name: '滋賀県', value: 24 },
        { name: '京都府', value: 25 },
        { name: '三重県', value: 26 },
        { name: '和歌山県', value: 27 },
        { name: '奈良県', value: 28 },
        { name: '大阪府', value: 29 },
        { name: '兵庫県', value: 30 },
        { name: '鳥取県', value: 31 },
        { name: '島根県', value: 32 },
        { name: '岡山県', value: 33 },
        { name: '広島県', value: 34 },
        { name: '山口県', value: 35 },
        { name: '高知県', value: 36 },
        { name: '徳島県', value: 37 },
        { name: '香川県', value: 38 },
        { name: '愛媛県', value: 39 },
        { name: '福岡県', value: 40 },
        { name: '佐賀県', value: 41 },
        { name: '長崎県', value: 42 },
        { name: '熊本県', value: 43 },
        { name: '宮崎県', value: 44 },
        { name: '大分県', value: 45 },
        { name: '鹿児島県', value: 46 },
        { name: '沖縄県', value: 47 }
      ],

      columns: [
        { code: 'id', show: false, def: false, name: 'ID' },
        { code: 'office_id', show: false, def: false, name: '営業所' },
        { code: 'user_id', show: false, def: false, name: '登録者' },
        { code: 'state', show: false, def: false, name: '状態' },
        { code: 'registration_date', show: false, def: false, name: '登録日' },
        { code: 'name', show: true, def: false, name: '名前' },
        { code: 'kana', show: true, def: true, name: 'なまえ' },
        { code: 'gender', show: false, def: true, name: '性別' },
        { code: 'birthday', show: false, def: false, name: '生年月日' },
        { code: 'age_start', show: false, def: true, name: '年齢' },
        { code: 'age_end', show: false, def: true, name: '~年齢' },
        { code: 'zip', show: false, def: false, name: '郵便番号' },
        { code: 'pref', show: true, def: true, name: '都道府県' },
        { code: 'address', show: true, def: true, name: '住所' },
        { code: 'tel1', show: true, def: true, name: '携帯TEL' },
        { code: 'tel2', show: false, def: false, name: '固定TEL' },
        { code: 'mail1', show: false, def: false, name: 'MAIL1' },
        { code: 'mail2', show: false, def: false, name: 'MAIL2' },
        { code: 'home_zip', show: false, def: false, name: '実家郵便番号' },
        { code: 'home_pref', show: false, def: false, name: '実家都道府県' },
        { code: 'home_address', show: false, def: false, name: '実家住所' },
        { code: 'home_tel', show: false, def: false, name: '実家TEL' },
        { code: 'school_name', show: false, def: true, name: '学校名' },
        { code: 'school_stage', show: false, def: false, name: '区分' },
        { code: 'department', show: false, def: false, name: '学部' },
        { code: 'old_grade', show: false, def: false, name: '旧学年' },
        { code: 'grade', show: false, def: false, name: '学年' },
        { code: 'grade_flag', show: false, def: false, name: '留年・浪人' },
        { code: 'department_type', show: false, def: false, name: '文/理' },
        { code: 'club', show: false, def: false, name: 'サークル' },
        { code: 'high_school_name', show: false, def: false, name: '高校部活' },
        { code: 'high_school_club', show: false, def: false, name: '出身高校' },
        { code: 'transportation_car', show: false, def: true, name: '車' },
        { code: 'transportation_bike', show: false, def: true, name: 'バイク' },
        { code: 'transportation_scooters', show: false, def: true, name: '原付' },
        { code: 'transportation_bicycle', show: false, def: true, name: '自転車' },
        { code: 'transportation_train', show: false, def: false, name: '電車' },
        { code: 'nearest_station', show: false, def: false, name: '最寄駅' },
        { code: 'exam_s', show: false, def: false, name: '小学受験' },
        { code: 'exam_c', show: false, def: false, name: '中学受験' },
        { code: 'exam_k', show: false, def: false, name: '高校受験' },
        { code: 'exam_d', show: false, def: false, name: '大学受験' },
        { code: 'experience_tutor', show: false, def: false, name: '家庭教師経験' },
        { code: 'experience_tutor_note', show: false, def: false, name: '家庭教師経験備考' },
        { code: 'experience_cram', show: false, def: false, name: '塾講師経験' },
        { code: 'experience_cram_note', show: false, def: false, name: '塾講師経験備考' },
        { code: 'channel_id', show: false, def: false, name: '登録媒体' },
        { code: 'medium_note', show: false, def: false, name: '備考(登録媒体)' },
        { code: 'published', show: false, def: false, name: 'HP/パンフ掲載' },
        { code: 'information', show: false, def: false, name: '情報発信' },
        { code: 'impression', show: false, def: true, name: '印象ランク' },
        { code: 'impression_note', show: false, def: false, name: '印象ランク備考' },
        { code: 'training', show: false, def: false, name: '研修' },
        { code: 'training_note', show: false, def: false, name: '研修備考' },
        { code: 'ssk', show: false, def: false, name: 'SSK' },
        { code: 'created_at', show: false, def: false, name: '作成日' },
        { code: 'updated_at', show: false, def: false, name: '更新日' },
        { code: 'note', show: false, def: false, name: '備考' }
      ],

      search: {
        id: '',
        office_id: '',
        user_id: '',
        state: '',
        registration_date: [],
        name: '',
        kana: '',
        gender: '',
        birthday: '',
        age: [],
        zip: '',
        pref: '',
        address: '',
        tel1: '',
        tel2: '',
        mail1: '',
        mail2: '',
        home_zip: '',
        home_pref: '',
        home_address: '',
        home_tel: '',
        school_name: '',
        school_stage: '',
        department: '',
        old_grade: '',
        grade: '',
        grade_flag: '',
        department_type: '',
        club: '',
        transportation_car: '',
        transportation_bike: '',
        transportation_scooters: '',
        transportation_bicycle: '',
        transportation_train: '',
        transportation_none: '',
        nearest_station: '',
        high_school_name: '',
        high_school_club: '',
        exam_s: '',
        exam_c: '',
        exam_k: '',
        exam_d: '',
        experience_tutor: '',
        experience_tutor_note: '',
        experience_cram: '',
        experience_cram_note: '',
        experience_none: '',
        channel_id: '',
        medium_note: '',
        published: '',
        information: '',
        impression: '',
        impression_note: '',
        training: '',
        training_note: '',
        ssk: '',
        note: '',
        created_at: '',
        updated_at: '',

        not_id: '',
        not_office_id: '',
        not_user_id: '',
        not_state: { name: '指導不可', value: 2 },
        not_registration_date: [],
        not_name: '',
        not_kana: '',
        not_gender: '',
        not_birthday: '',
        not_age: [],
        not_zip: '',
        not_pref: '',
        not_address: '',
        not_tel1: '',
        not_tel2: '',
        not_mail1: '',
        not_mail2: '',
        not_home_zip: '',
        not_home_pref: '',
        not_home_address: '',
        not_home_tel: '',
        not_school_name: '',
        not_school_stage: '',
        not_department: '',
        not_old_grade: '',
        not_grade: '',
        not_grade_flag: '',
        not_department_type: '',
        not_club: '',
        not_transportation_car: '',
        not_transportation_bike: '',
        not_transportation_scooters: '',
        not_transportation_bicycle: '',
        not_transportation_train: '',
        not_transportation_none: '',
        not_nearest_station: '',
        not_high_school_name: '',
        not_high_school_club: '',
        not_exam_s: '',
        not_exam_c: '',
        not_exam_k: '',
        not_exam_d: '',
        not_experience_tutor: '',
        not_experience_tutor_note: '',
        not_experience_cram: '',
        not_experience_cram_note: '',
        not_experience_none: '',
        not_channel_id: '',
        not_medium_note: '',
        not_published: '',
        not_information: '',
        not_impression: '',
        not_impression_note: '',
        not_training: '',
        not_training_note: '',
        not_ssk: '',
        not_note: '',
        not_created_at: '',
        not_updated_at: ''
      },

      watch: {
        office_id: '',
        user_id: '',
        state: '',
        pref: [],
        home_pref: '',
        gender: '',
        school_stage: '',
        old_grade: '',
        grade: '',
        department_type: '',
        transportation_car: '',
        transportation_bike: '',
        transportation_scooters: '',
        transportation_bicycle: '',
        transportation_train: '',
        exam_s: '',
        exam_c: '',
        exam_k: '',
        exam_d: '',
        experience_tutor: '',
        experience_cram: '',
        published: '',
        information: '',
        channel_id: '',
        impression: '',
        training: '',
        ssk: '',

        not_office_id: '',
        not_user_id: '',
        not_state: '',
        not_pref: [],
        not_home_pref: '',
        not_gender: '',
        not_school_stage: '',
        not_old_grade: '',
        not_grade: '',
        not_department_type: '',
        not_transportation_car: '',
        not_transportation_bike: '',
        not_transportation_scooters: '',
        not_transportation_bicycle: '',
        not_transportation_train: '',
        not_exam_s: '',
        not_exam_c: '',
        not_exam_k: '',
        not_exam_d: '',
        not_experience_tutor: '',
        not_experience_cram: '',
        not_published: '',
        not_information: '',
        not_channel_id: '',
        not_impression: '',
        not_training: '',
        not_ssk: ''
      }
    }
  },

  computed: {
    obj () {
      return obj
    },

    max () {
      return this.$store.getters.max
    },

    state () {
      return this.$store.getters['tutors/state']
    },

    gender () {
      return this.$store.getters['tutors/gender']
    },

    school_stage () {
      return this.$store.getters['tutors/school_stage']
    },

    grade () {
      return this.$store.getters['tutors/grade']
    },

    old_grade () {
      return this.$store.getters['tutors/old_grade']
    },

    department_type () {
      return this.$store.getters['tutors/department_type']
    },

    impression () {
      return this.$store.getters['tutors/impression']
    },

    yesno () {
      return this.$store.getters['tutors/yesno']
    },

    marubatu () {
      return this.$store.getters['tutors/marubatu']
    },

    possible () {
      return this.$store.getters['tutors/possible']
    },

    training () {
      return this.$store.getters['tutors/training']
    },

    ssk () {
      return this.$store.getters['tutors/ssk']
    },

    tutors () {
      return this.$store.getters.tutors
    },

    offices () {
      return this.$store.getters.offices
    },

    users () {
      return this.$store.getters.users
    },

    user () {
      return this.$store.getters.user
    },

    prefs () {
      return this.$store.getters.prefs.reverse()
    },

    channels () {
      return this.$store.getters.channels
    },

    orderedChannels () {
      return _.orderBy(this.channels, 'id')
    },

    filteredChannels () {
      let self = this
      return self.orderedChannels.filter(channel => {
        return channel.state === 1
      })
    },

    orderedTutors () {
      if (this.sortState === '' || this.sortState === '降順') {
        return _.orderBy(this.tutors, this.sortColumn).reverse()
      } else if (this.sortState === '昇順') {
        return _.orderBy(this.tutors, this.sortColumn)
      }
    },

    mapTutors () {
      let self = this
      return self.orderedTutors.map(tutor => {
        tutor.mapState = self.calcSelect(tutor.state, 'state')
        tutor.mapGender = self.calcSelect(tutor.gender, 'gender')
        tutor.age = self.calcAge(tutor.birthday)
        tutor.grade = self.calcGrade(tutor.birthday, tutor.grade_flag, tutor.school_stage)
        tutor.mapOldGrade = self.calcOldGrade(tutor.old_grade)
        tutor.mapDepartmentType = self.calcSelect(tutor.department_type, 'department_type')
        tutor.mapImpression = self.calcSelect(tutor.impression, 'impression')
        tutor.mapSchoolStage = self.calcSelect(tutor.school_stage, 'school_stage')
        tutor.mapOffice = self.calcArry(tutor.office_id, 'offices')
        tutor.mapPref = self.calcArry(tutor.pref, 'prefs')
        tutor.mapHomePref = self.calcArry(tutor.home_pref, 'prefs')
        tutor.mapCar = self.calcSelect(tutor.transportation_car, 'marubatu')
        tutor.mapBike = self.calcSelect(tutor.transportation_bike, 'marubatu')
        tutor.mapScooters = self.calcSelect(tutor.transportation_scooters, 'marubatu')
        tutor.mapBicycle = self.calcSelect(tutor.transportation_bicycle, 'marubatu')
        tutor.mapTrain = self.calcSelect(tutor.transportation_train, 'marubatu')
        tutor.mapExamS = self.calcSelect(tutor.exam_s, 'yesno')
        tutor.mapExamC = self.calcSelect(tutor.exam_c, 'yesno')
        tutor.mapExamK = self.calcSelect(tutor.exam_k, 'yesno')
        tutor.mapExamD = self.calcSelect(tutor.exam_d, 'yesno')
        tutor.mapExperienceTutor = self.calcSelect(tutor.experience_tutor, 'yesno')
        tutor.mapExperienceCram = self.calcSelect(tutor.experience_cram, 'yesno')
        tutor.mapPublished = self.calcSelect(tutor.published, 'possible')
        tutor.mapInformation = self.calcSelect(tutor.information, 'possible')
        tutor.mapTraining = self.calcSelect(tutor.training, 'training')
        tutor.mapSsk = self.calcSelect(tutor.ssk, 'ssk')
        return tutor
      })
    },

    filteredTutors () {
      let self = this
      return self.mapTutors.filter((tutor) => {
        return tutor.state !== 2
      })
    }
  },

  watch: {
    'watch.office_id': function (now, old) {
      if (now) {
        this.search.office_id = now.id
      } else {
        this.search.office_id = ''
      }
    },

    'watch.not_office_id': function (now, old) {
      if (now) {
        this.search.not_office_id = now.id
      } else {
        this.search.not_office_id = ''
      }
    },

    'watch.user_id': function (now, old) {
      if (now) {
        this.search.user_id = now.id
      } else {
        this.search.user_id = ''
      }
    },

    'watch.not_user_id': function (now, old) {
      if (now) {
        this.search.not_user_id = now.id
      } else {
        this.search.not_user_id = ''
      }
    },

    'watch.state': function (now, old) {
      if (now) {
        this.search.state = now.value
      } else {
        this.search.state = ''
      }
    },

    'watch.not_state': function (now, old) {
      if (now) {
        this.search.not_state = now.value
      } else {
        this.search.not_state = ''
      }
    },

    'watch.gender': function (now, old) {
      if (now) {
        this.search.gender = now.value
      } else {
        this.search.gender = ''
      }
    },

    'watch.not_gender': function (now, old) {
      if (now) {
        this.search.not_gender = now.value
      } else {
        this.search.not_gender = ''
      }
    },

    'watch.pref': function (now, old) {
      if (now) {
        this.search.pref = ''
        for (let i = 0; i < now.length; i++) {
          this.search.pref += now[i].id + ' '
        }
        this.searchTable()
      }
    },

    'watch.not_pref': function (now, old) {
      if (now) {
        this.search.not_pref = ''
        for (let i = 0; i < now.length; i++) {
          this.search.not_pref += now[i].id + ' '
        }
        this.searchTable()
      }
    },

    'watch.home_pref': function (now, old) {
      if (now) {
        this.search.home_pref = now.id
      } else {
        this.search.home_pref = ''
      }
    },

    'watch.not_home_pref': function (now, old) {
      if (now) {
        this.search.not_home_pref = now.id
      } else {
        this.search.not_home_pref = ''
      }
    },

    'watch.school_stage': function (now, old) {
      if (now) {
        this.search.school_stage = now.value
      } else {
        this.search.school_stage = ''
      }
    },

    'watch.not_school_stage': function (now, old) {
      if (now) {
        this.search.not_school_stage = now.value
      } else {
        this.search.not_school_stage = ''
      }
    },

    'watch.old_grade': function (now, old) {
      if (now) {
        this.search.old_grade = now.value
      } else {
        this.search.old_grade = ''
      }
    },

    'watch.not_old_grade': function (now, old) {
      if (now) {
        this.search.not_old_grade = now.value
      } else {
        this.search.not_old_grade = ''
      }
    },

    'watch.department_type': function (now, old) {
      if (now) {
        this.search.department_type = now.value
      } else {
        this.search.department_type = ''
      }
    },

    'watch.not_department_type': function (now, old) {
      if (now) {
        this.search.not_department_type = now.value
      } else {
        this.search.not_department_type = ''
      }
    },

    'watch.transportation_car': function (now, old) {
      if (now) {
        this.search.transportation_car = now.value
      } else {
        this.search.transportation_car = ''
      }
    },

    'watch.not_transportation_car': function (now, old) {
      if (now) {
        this.search.not_transportation_car = now.value
      } else {
        this.search.not_transportation_car = ''
      }
    },

    'watch.transportation_bike': function (now, old) {
      if (now) {
        this.search.transportation_bike = now.value
      } else {
        this.search.transportation_bike = ''
      }
    },

    'watch.not_transportation_bike': function (now, old) {
      if (now) {
        this.search.not_transportation_bike = now.value
      } else {
        this.search.not_transportation_bike = ''
      }
    },

    'watch.transportation_scooters': function (now, old) {
      if (now) {
        this.search.transportation_scooters = now.value
      } else {
        this.search.transportation_scooters = ''
      }
    },

    'watch.not_transportation_scooters': function (now, old) {
      if (now) {
        this.search.not_transportation_scooters = now.value
      } else {
        this.search.not_transportation_scooters = ''
      }
    },

    'watch.transportation_bicycle': function (now, old) {
      if (now) {
        this.search.transportation_bicycle = now.value
      } else {
        this.search.transportation_bicycle = ''
      }
    },

    'watch.not_transportation_bicycle': function (now, old) {
      if (now) {
        this.search.not_transportation_bicycle = now.value
      } else {
        this.search.not_transportation_bicycle = ''
      }
    },

    'watch.transportation_train': function (now, old) {
      if (now) {
        this.search.transportation_train = now.value
      } else {
        this.search.transportation_train = ''
      }
    },

    'watch.not_transportation_train': function (now, old) {
      if (now) {
        this.search.not_transportation_train = now.value
      } else {
        this.search.not_transportation_train = ''
      }
    },

    'watch.exam_s': function (now, old) {
      if (now) {
        this.search.exam_s = now.value
      } else {
        this.search.exam_s = ''
      }
    },

    'watch.not_exam_s': function (now, old) {
      if (now) {
        this.search.not_exam_s = now.value
      } else {
        this.search.not_exam_s = ''
      }
    },

    'watch.exam_c': function (now, old) {
      if (now) {
        this.search.exam_c = now.value
      } else {
        this.search.exam_c = ''
      }
    },

    'watch.not_exam_c': function (now, old) {
      if (now) {
        this.search.not_exam_c = now.value
      } else {
        this.search.not_exam_c = ''
      }
    },

    'watch.exam_k': function (now, old) {
      if (now) {
        this.search.exam_k = now.value
      } else {
        this.search.exam_k = ''
      }
    },

    'watch.not_exam_k': function (now, old) {
      if (now) {
        this.search.not_exam_k = now.value
      } else {
        this.search.not_exam_k = ''
      }
    },

    'watch.exam_d': function (now, old) {
      if (now) {
        this.search.exam_d = now.value
      } else {
        this.search.exam_d = ''
      }
    },

    'watch.not_exam_d': function (now, old) {
      if (now) {
        this.search.not_exam_d = now.value
      } else {
        this.search.not_exam_d = ''
      }
    },

    'watch.experience_tutor': function (now, old) {
      if (now) {
        this.search.experience_tutor = now.value
      } else {
        this.search.experience_tutor = ''
      }
    },

    'watch.not_experience_tutor': function (now, old) {
      if (now) {
        this.search.not_experience_tutor = now.value
      } else {
        this.search.not_experience_tutor = ''
      }
    },

    'watch.experience_cram': function (now, old) {
      if (now) {
        this.search.experience_cram = now.value
      } else {
        this.search.experience_cram = ''
      }
    },

    'watch.not_experience_cram': function (now, old) {
      if (now) {
        this.search.not_experience_cram = now.value
      } else {
        this.search.not_experience_cram = ''
      }
    },

    'watch.channel_id': function (now, old) {
      if (now) {
        this.search.channel_id = now.id
      } else {
        this.search.channel_id = ''
      }
    },

    'watch.not_channel_id': function (now, old) {
      if (now) {
        this.search.not_channel_id = now.id
      } else {
        this.search.not_channel_id = ''
      }
    },

    'watch.published': function (now, old) {
      if (now) {
        this.search.published = now.value
      } else {
        this.search.published = ''
      }
    },

    'watch.not_published': function (now, old) {
      if (now) {
        this.search.not_published = now.value
      } else {
        this.search.not_published = ''
      }
    },

    'watch.information': function (now, old) {
      if (now) {
        this.search.information = now.value
      } else {
        this.search.information = ''
      }
    },

    'watch.not_information': function (now, old) {
      if (now) {
        this.search.not_information = now.value
      } else {
        this.search.not_information = ''
      }
    },

    'watch.impression': function (now, old) {
      if (now) {
        this.search.impression = now.value
      } else {
        this.search.impression = ''
      }
    },

    'watch.not_impression': function (now, old) {
      if (now) {
        this.search.not_impression = now.value
      } else {
        this.search.not_impression = ''
      }
    },

    'watch.training': function (now, old) {
      if (now) {
        this.search.training = now.value
      } else {
        this.search.training = ''
      }
    },

    'watch.not_training': function (now, old) {
      if (now) {
        this.search.not_training = now.value
      } else {
        this.search.not_training = ''
      }
    },

    'watch.ssk': function (now, old) {
      if (now) {
        this.search.ssk = now.value
      } else {
        this.search.ssk = ''
      }
    },

    'watch.not_ssk': function (now, old) {
      if (now) {
        this.search.not_ssk = now.value
      } else {
        this.search.not_ssk = ''
      }
    }
  },

  methods: {
    calcArry (val, text) {
      if (val) {
        return this[text].filter(item => {
          return item.id === val
        })[0].name
      } else {
        return
      }
    },

    calcSelect (val, text) {
      if (val) {
        return this[text].filter(item => {
          return item.value === val
        })[0].name
      } else {
        return
      }
    },

    // calcOffice (val) {
    //   if (val) {
    //     return this.offices.filter(item => {
    //       return item.id === val
    //     })[0].name
    //   } else {
    //     return
    //   }
    // },

    // calcPref (val) {
    //   if (val) {
    //     return this.prefs.filter(item => {
    //       return item.id === val
    //     })[0].name
    //   } else {
    //     return
    //   }
    // },

    // calcSchoolStage (val) {
    //   if (val) {
    //     return this.school_stage.filter(item => {
    //       return item.value === val
    //     })[0].name
    //   } else {
    //     return
    //   }
    // },

    calcOldGrade (val) {
      if (val) {
        const old_gradeTrue = this.old_grade.filter(item => {
          return item.value === val
        })[0]
        if (old_gradeTrue) {
          old_gradeTrue.name
        } else {
          return // valueが該当しないものではいっている。104とか
        }
      } else {
        return
      }
    },

    // calcDepartmentType (val) {
    //   if (val) {
    //     return this.department_type.filter(item => {
    //       return item.value === val
    //     })[0].name
    //   } else {
    //     return
    //   }
    // },

    // calcImpression (val) {
    //   if (val) {
    //     return this.impression.filter(item => {
    //       return item.value === val
    //     })[0].name
    //   } else {
    //     return
    //   }
    // },

    calcAge (birthday) {
      let x = Date.parse(birthday) // 変換(ミリ秒が返される)
      let date = new Date(x) // ミリ秒をnew Dateに渡す
      let ageDifMs = Date.now() - date // 差分(ミリ秒)
      let ageDate = new Date(ageDifMs) // ミリ秒をnew Dateに渡す
      return ageDate.getUTCFullYear() - 1970
    },

    calcGrade (birthday, grade_flag, school_stage) {
      let x = Date.parse(birthday) // 変換(ミリ秒が返される)
      let birthdate = new Date(x) // ミリ秒をnew Dateに渡す

      // ****/01/01-****/04/01の期間中は学年を上げない
      let year = new Date().getFullYear()
      if (new Date() >= new Date(new Date().getFullYear(), 0, 1) && new Date() <= new Date(new Date().getFullYear(), 3, 1, 23, 59)) {
        year = year - 1
      }

      let ageNumber
      for (let i = 0; i < 100; i++) {
        if (birthdate >= new Date(year - i, 3, 2) && birthdate <= new Date(year - (i - 1), 3, 1, 23, 59)) {
          ageNumber = i
        }
      }

      let gradeNumber = ageNumber + Number(grade_flag)

      let grade
      if (gradeNumber === 4) {
        grade = '幼稚園年少'
      } else if (gradeNumber === 5) {
        grade = '幼稚園年中'
      } else if (gradeNumber === 6) {
        grade = '幼稚園年長'
      } else if (gradeNumber === 7) {
        grade = '小学1年生'
      } else if (gradeNumber === 8) {
        grade = '小学2年生'
      } else if (gradeNumber === 9) {
        grade = '小学3年生'
      } else if (gradeNumber === 10) {
        grade = '小学4年生'
      } else if (gradeNumber === 11) {
        grade = '小学5年生'
      } else if (gradeNumber === 12) {
        grade = '小学6年生'
      } else if (gradeNumber === 13) {
        grade = '中学1年生'
      } else if (gradeNumber === 14) {
        grade = '中学2年生'
      } else if (gradeNumber === 15) {
        grade = '中学3年生'
      } else if (gradeNumber === 16) {
        grade = '高校1年生'
      } else if (gradeNumber === 17) {
        grade = '高校2年生'
      } else if (gradeNumber === 18) {
        grade = '高校3年生'
      } else if (gradeNumber === 19) {
        if (school_stage === 0) {
          grade = '区分未選択'
        } else if (school_stage === 1) {
          grade = '大学1年生'
        } else if (school_stage === 2) {
          grade = '大学1年生'
        } else if (school_stage === 3) {
          grade = '専門1年生'
        } else if (school_stage === 4) {
          grade = '高校卒業'
        } else if (school_stage === 5) {
          grade = '大学1年生'
        } else if (school_stage === 6) {
          grade = '専門1年生'
        } else if (school_stage === 7) {
          grade = '短大1年生'
        } else if (school_stage === 8) {
          grade = '高専4年生'
        } else if (school_stage === 9) {
          grade = '大学1年生'
        } else if (school_stage === 10) {
          grade = '専門1年生'
        } else if (school_stage === 11) {
          grade = '大学1年生'
        }
      } else if (gradeNumber === 20) {
        if (school_stage === 0) {
          grade = '区分未選択'
        } else if (school_stage === 1) {
          grade = '大学2年生'
        } else if (school_stage === 2) {
          grade = '大学2年生'
        } else if (school_stage === 3) {
          grade = '専門2年生'
        } else if (school_stage === 4) {
          grade = '高校卒業'
        } else if (school_stage === 5) {
          grade = '大学2年生'
        } else if (school_stage === 6) {
          grade = '専門2年生'
        } else if (school_stage === 7) {
          grade = '短大2年生'
        } else if (school_stage === 8) {
          grade = '高専5年生'
        } else if (school_stage === 9) {
          grade = '大学2年生'
        } else if (school_stage === 10) {
          grade = '専門2年生'
        } else if (school_stage === 11) {
          grade = '大学2年生'
        }
      } else if (gradeNumber === 21) {
        if (school_stage === 0) {
          grade = '区分未選択'
        } else if (school_stage === 1) {
          grade = '大学3年生'
        } else if (school_stage === 2) {
          grade = '大学3年生'
        } else if (school_stage === 3) {
          grade = '専門2年制卒業'
        } else if (school_stage === 4) {
          grade = '高校卒業'
        } else if (school_stage === 5) {
          grade = '大学3年生'
        } else if (school_stage === 6) {
          grade = '専門3年生'
        } else if (school_stage === 7) {
          grade = '短大2年制卒業'
        } else if (school_stage === 8) {
          grade = '高専卒業'
        } else if (school_stage === 9) {
          grade = '大学3年生'
        } else if (school_stage === 10) {
          grade = '専門卒業'
        } else if (school_stage === 11) {
          grade = '大学3年生'
        }
      } else if (gradeNumber === 22) {
        if (school_stage === 0) {
          grade = '区分未選択'
        } else if (school_stage === 1) {
          grade = '大学4年生'
        } else if (school_stage === 2) {
          grade = '大学4年生'
        } else if (school_stage === 3) {
          grade = '専門2年制卒業'
        } else if (school_stage === 4) {
          grade = '高校卒業'
        } else if (school_stage === 5) {
          grade = '大学4年生'
        } else if (school_stage === 6) {
          grade = '専門3年制卒業'
        } else if (school_stage === 7) {
          grade = '短大2年制卒業'
        } else if (school_stage === 8) {
          grade = '高専卒業'
        } else if (school_stage === 9) {
          grade = '大学4年生'
        } else if (school_stage === 10) {
          grade = '専門卒業'
        } else if (school_stage === 11) {
          grade = '大学4年生'
        }
      } else if (gradeNumber === 23) {
        if (school_stage === 0) {
          grade = '区分未選択'
        } else if (school_stage === 1) {
          grade = '大学4年制卒業'
        } else if (school_stage === 2) {
          grade = '大学M1'
        } else if (school_stage === 3) {
          grade = '専門2年制卒業'
        } else if (school_stage === 4) {
          grade = '高校卒業'
        } else if (school_stage === 5) {
          grade = '大学5年生'
        } else if (school_stage === 6) {
          grade = '専門3年制卒業'
        } else if (school_stage === 7) {
          grade = '短大2年制卒業'
        } else if (school_stage === 8) {
          grade = '高専卒業'
        } else if (school_stage === 9) {
          grade = '大学卒業'
        } else if (school_stage === 10) {
          grade = '専門卒業'
        } else if (school_stage === 11) {
          grade = '大学M1'
        }
      } else if (gradeNumber === 24) {
        if (school_stage === 0) {
          grade = '区分未選択'
        } else if (school_stage === 1) {
          grade = '大学4年制卒業'
        } else if (school_stage === 2) {
          grade = '大学M2'
        } else if (school_stage === 3) {
          grade = '専門2年制卒業'
        } else if (school_stage === 4) {
          grade = '高校卒業'
        } else if (school_stage === 5) {
          grade = '大学6年生'
        } else if (school_stage === 6) {
          grade = '専門3年制卒業'
        } else if (school_stage === 7) {
          grade = '短大2年制卒業'
        } else if (school_stage === 8) {
          grade = '高専卒業'
        } else if (school_stage === 9) {
          grade = '大学卒業'
        } else if (school_stage === 10) {
          grade = '専門卒業'
        } else if (school_stage === 11) {
          grade = '大学M2'
        }
      } else if (gradeNumber === 25) {
        if (school_stage === 0) {
          grade = '区分未選択'
        } else if (school_stage === 1) {
          grade = '大学4年制卒業'
        } else if (school_stage === 2) {
          grade = '大学院卒業'
        } else if (school_stage === 3) {
          grade = '専門2年制卒業'
        } else if (school_stage === 4) {
          grade = '高校卒業'
        } else if (school_stage === 5) {
          grade = '大学6年制卒業'
        } else if (school_stage === 6) {
          grade = '専門3年制卒業'
        } else if (school_stage === 7) {
          grade = '短大2年制卒業'
        } else if (school_stage === 8) {
          grade = '高専卒業'
        } else if (school_stage === 9) {
          grade = '大学卒業'
        } else if (school_stage === 10) {
          grade = '専門卒業'
        } else if (school_stage === 11) {
          grade = '大学D1'
        }
      } else if (gradeNumber === 26) {
        if (school_stage === 0) {
          grade = '区分未選択'
        } else if (school_stage === 1) {
          grade = '大学4年制卒業'
        } else if (school_stage === 2) {
          grade = '大学院卒業'
        } else if (school_stage === 3) {
          grade = '専門2年制卒業'
        } else if (school_stage === 4) {
          grade = '高校卒業'
        } else if (school_stage === 5) {
          grade = '大学6年制卒業'
        } else if (school_stage === 6) {
          grade = '専門3年制卒業'
        } else if (school_stage === 7) {
          grade = '短大2年制卒業'
        } else if (school_stage === 8) {
          grade = '高専卒業'
        } else if (school_stage === 9) {
          grade = '大学卒業'
        } else if (school_stage === 10) {
          grade = '専門卒業'
        } else if (school_stage === 11) {
          grade = '大学D2'
        }
      } else if (gradeNumber > 26) {
        if (school_stage === 0) {
          grade = '区分未選択'
        } else if (school_stage === 1) {
          grade = '大学4年制卒業'
        } else if (school_stage === 2) {
          grade = '大学院卒業'
        } else if (school_stage === 3) {
          grade = '専門2年制卒業'
        } else if (school_stage === 4) {
          grade = '高校卒業'
        } else if (school_stage === 5) {
          grade = '大学6年制卒業'
        } else if (school_stage === 6) {
          grade = '専門3年制卒業'
        } else if (school_stage === 7) {
          grade = '短大2年制卒業'
        } else if (school_stage === 8) {
          grade = '高専卒業'
        } else if (school_stage === 9) {
          grade = '大学卒業'
        } else if (school_stage === 10) {
          grade = '専門卒業'
        } else if (school_stage === 11) {
          grade = '博士課程卒業'
        }
      } else {
        grade = ''
      }
      return grade
    },

    next () {
      if (this.nowIndex + 1 === this.mapTutors.length) {
        alert('これ以上進めません')
      } else {
        this.nowIndex = this.nowIndex + 1
        const arr = [
          'id',
          'office_id',
          'user_id',
          'state',
          'registration_date',
          'f_name',
          'l_name',
          'f_name_kana',
          'l_name_kana',
          'gender',
          'birthday',
          'zip',
          'pref',
          'address1',
          'address2',
          'tel1',
          'tel2',
          'mail1',
          'mail2',
          'home_zip',
          'home_pref',
          'home_address',
          'home_tel',
          'school_name',
          'school_stage',
          'department',
          'old_grade',
          'grade',
          'grade_flag',
          'department_type',
          'club',
          'transportation_car',
          'transportation_bike',
          'transportation_scooters',
          'transportation_bicycle',
          'transportation_train',
          'transportation_none',
          'nearest_station',
          'high_school_name',
          'high_school_club',
          'exam_s',
          'exam_c',
          'exam_k',
          'exam_d',
          'experience_tutor',
          'experience_tutor_note',
          'experience_cram',
          'experience_cram_note',
          'experience_none',
          'channel_id',
          'medium_note',
          'published',
          'information',
          'impression',
          'impression_note',
          'training',
          'training_note',
          'ssk',
          'note',
          'created_at'
        ]
        arr.forEach((item) => {
          this.$store.state.item.tutor[item] = this.mapTutors[this.nowIndex][item]
        })
        if (this.mapTutors[this.nowIndex].lat === null) {
          this.$store.dispatch('getGeo', {
            this: this,
            tutor: this.mapTutors[this.nowIndex],
            pref: this.pref
          })
        }
        this.$store.dispatch('getTutor', this.mapTutors[this.nowIndex].id)
        // this.$store.dispatch('getTutors') // 座標更新したいけど検索外れるのでコメントアウト
        this.$router.push({name: this.routeName.name, params: { id: this.mapTutors[this.nowIndex].id }})
      }
    },

    prev () {
      if (this.nowIndex === 0) {
        alert('これ以上戻れません')
      } else {
        this.nowIndex = this.nowIndex - 1
        const arr = [
          'id',
          'office_id',
          'user_id',
          'state',
          'registration_date',
          'f_name',
          'l_name',
          'f_name_kana',
          'l_name_kana',
          'gender',
          'birthday',
          'zip',
          'pref',
          'address1',
          'address2',
          'tel1',
          'tel2',
          'mail1',
          'mail2',
          'home_zip',
          'home_pref',
          'home_address',
          'home_tel',
          'school_name',
          'school_stage',
          'department',
          'old_grade',
          'grade',
          'grade_flag',
          'department_type',
          'club',
          'transportation_car',
          'transportation_bike',
          'transportation_scooters',
          'transportation_bicycle',
          'transportation_train',
          'transportation_none',
          'nearest_station',
          'high_school_name',
          'high_school_club',
          'exam_s',
          'exam_c',
          'exam_k',
          'exam_d',
          'experience_tutor',
          'experience_tutor_note',
          'experience_cram',
          'experience_cram_note',
          'experience_none',
          'channel_id',
          'medium_note',
          'published',
          'information',
          'impression',
          'impression_note',
          'training',
          'training_note',
          'ssk',
          'note',
          'created_at'
        ]
        arr.forEach((item) => {
          this.$store.state.item.tutor[item] = this.mapTutors[this.nowIndex][item]
        })
        if (this.mapTutors[this.nowIndex].lat === null) {
          this.$store.dispatch('getGeo', {
            this: this,
            tutor: this.mapTutors[this.nowIndex],
            pref: this.pref
          })
        }
        this.$store.dispatch('getTutor', this.mapTutors[this.nowIndex].id)
        // this.$store.dispatch('getTutors') // 座標更新したいけど検索外れるのでコメントアウト
        this.$router.push({name: this.routeName.name, params: { id: this.mapTutors[this.nowIndex].id }})
      }
    },

    linkTutor (list, index) {
      this.nowIndex = index
      const arr = [
        'id',
        'office_id',
        'user_id',
        'state',
        'registration_date',
        'f_name',
        'l_name',
        'f_name_kana',
        'l_name_kana',
        'gender',
        'birthday',
        'zip',
        'pref',
        'address1',
        'address2',
        'tel1',
        'tel2',
        'mail1',
        'mail2',
        'home_zip',
        'home_pref',
        'home_address',
        'home_tel',
        'school_name',
        'school_stage',
        'department',
        'old_grade',
        'grade',
        'grade_flag',
        'department_type',
        'club',
        'transportation_car',
        'transportation_bike',
        'transportation_scooters',
        'transportation_bicycle',
        'transportation_train',
        'transportation_none',
        'nearest_station',
        'high_school_name',
        'high_school_club',
        'exam_s',
        'exam_c',
        'exam_k',
        'exam_d',
        'experience_tutor',
        'experience_tutor_note',
        'experience_cram',
        'experience_cram_note',
        'experience_none',
        'channel_id',
        'medium_note',
        'published',
        'information',
        'impression',
        'impression_note',
        'training',
        'training_note',
        'ssk',
        'note',
        'created_at'
      ]
      arr.forEach((item) => {
        this.$store.state.item.tutor[item] = list[item]
      })
      if (list.lat === null) {
        this.$store.dispatch('getGeo', {
          this: this,
          tutor: list,
          pref: this.pref
        })
      }
      this.$store.dispatch('getTutor', list.id)
      // this.$store.dispatch('getTutors') // 座標更新したいけど検索外れるのでコメントアウト
      this.$router.push({name: this.routeName.name, params: { id: list.id }})
    },

    switchColumns (col) {
      this[col] = !this[col]
    },

    switchV (col) {
      this.columns[col].show = !this.columns[col].show
    },

    reset () {
      for (let i = 0; i < this.columns.length; i++) {
        this.columns[i].show = false
      }
    },

    all () {
      for (let i = 0; i < this.columns.length; i++) {
        this.columns[i].show = true
      }
    },

    def () {
      for (let i = 0; i < this.columns.length; i++) {
        this.columns[i].show = this.columns[i].def
      }
    },

    sort (header) {
      if (this.sortState === '' || this.sortState === '降順') {
        this.sortState = '昇順'
        this.sortColumn = header
      } else if (this.sortState === '昇順') {
        this.sortState = '降順'
        this.sortColumn = header
      }
    },

    offset (e) {
      this.$store.dispatch('SCROLL', {
        this: this,
        e: e,
        obj: obj
      })
    },

    searchTable (e) {
      this.$store.dispatch('SEARCH', {
        this: this,
        e: e,
        obj: obj
      })
    },

    resetSearch () {
      this.search.id = ''
      this.watch.office_id = 0
      this.watch.user_id = 0
      this.watch.state = 0
      this.search.registration_date = []
      this.search.name = ''
      this.search.kana = ''
      this.watch.gender = 0
      this.search.birthday = ''
      this.search.age = []
      this.search.zip = ''
      this.watch.pref = []
      this.search.address = ''
      this.search.tel1 = ''
      this.search.tel2 = ''
      this.search.mail1 = ''
      this.search.mail2 = ''
      this.search.home_zip = ''
      this.watch.home_pref = 0
      this.search.home_address = ''
      this.search.home_tel = ''
      this.search.school_name = ''
      this.watch.school_stage = 0
      this.search.department = ''
      this.watch.old_grade = 0
      this.watch.grade = 0
      this.search.grade_flag = ''
      this.watch.department_type = 0
      this.search.club = ''
      this.watch.transportation_car = 0
      this.watch.transportation_bike = 0
      this.watch.transportation_scooters = 0
      this.watch.transportation_bicycle = 0
      this.watch.transportation_train = 0
      this.watch.transportation_none = 0
      this.search.nearest_station = ''
      this.search.high_school_name = ''
      this.search.high_school_club = ''
      this.watch.exam_s = 0
      this.watch.exam_c = 0
      this.watch.exam_k = 0
      this.watch.exam_d = 0
      this.watch.experience_tutor = 0
      this.search.experience_tutor_note = ''
      this.watch.experience_cram = 0
      this.search.experience_cram_note = ''
      this.watch.experience_none = 0
      this.watch.channel_id = 0
      this.search.medium_note = ''
      this.watch.published = 0
      this.watch.information = 0
      this.watch.impression = 0
      this.search.impression_note = ''
      this.watch.training = 0
      this.search.training_note = ''
      this.watch.ssk = 0
      this.search.note = ''

      this.search.not_id = ''
      this.watch.not_office_id = 0
      this.watch.not_user_id = 0
      this.watch.not_state = { name: '指導不可', value: 2 }
      this.search.not_registration_date = []
      this.search.not_name = ''
      this.search.not_kana = ''
      this.watch.not_gender = 0
      this.search.not_birthday = ''
      this.search.not_age = []
      this.search.not_zip = ''
      this.watch.not_pref = []
      this.search.not_address = ''
      this.search.not_tel1 = ''
      this.search.not_tel2 = ''
      this.search.not_mail1 = ''
      this.search.not_mail2 = ''
      this.search.not_home_zip = ''
      this.watch.not_home_pref = 0
      this.search.not_home_address = ''
      this.search.not_home_tel = ''
      this.search.not_school_name = ''
      this.watch.not_school_stage = 0
      this.search.not_department = ''
      this.watch.not_old_grade = 0
      this.watch.not_grade = 0
      this.search.not_grade_flag = ''
      this.watch.not_department_type = 0
      this.search.not_club = ''
      this.watch.not_transportation_car = 0
      this.watch.not_transportation_bike = 0
      this.watch.not_transportation_scooters = 0
      this.watch.not_transportation_bicycle = 0
      this.watch.not_transportation_train = 0
      this.watch.not_transportation_none = 0
      this.search.not_nearest_station = ''
      this.search.not_high_school_name = ''
      this.search.not_high_school_club = ''
      this.watch.not_exam_s = 0
      this.watch.not_exam_c = 0
      this.watch.not_exam_k = 0
      this.watch.not_exam_d = 0
      this.watch.not_experience_tutor = 0
      this.search.not_experience_tutor_note = ''
      this.watch.not_experience_cram = 0
      this.search.not_experience_cram_note = ''
      this.watch.not_experience_none = 0
      this.watch.not_channel_id = 0
      this.search.not_medium_note = ''
      this.watch.not_published = 0
      this.watch.not_information = 0
      this.watch.not_impression = 0
      this.search.not_impression_note = ''
      this.watch.not_training = 0
      this.search.not_training_note = ''
      this.watch.not_ssk = 0
      this.search.not_note = ''

      this.searchTable()
    }
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      // alert('get')
      let getjson = localStorage.getItem('Tutors2Search')
      let obj = JSON.parse(getjson)

      vm.search.id = obj['id']
      vm.watch.office_id = obj['office_id']
      vm.watch.user_id = obj['user_id']
      vm.watch.state = obj['state']
      vm.search.registration_date = obj['registration_date']
      vm.search.name = obj['name']
      vm.search.kana = obj['kana']
      vm.watch.gender = obj['gender']
      vm.search.birthday = obj['birthday']
      vm.search.age = obj['age']
      vm.search.zip = obj['zip']
      vm.watch.pref = obj['pref']
      vm.search.address = obj['address']
      vm.search.tel1 = obj['tel1']
      vm.search.tel2 = obj['tel2']
      vm.search.mail1 = obj['mail1']
      vm.search.mail2 = obj['mail2']
      vm.search.home_zip = obj['home_zip']
      vm.watch.home_pref = obj['home_pref']
      vm.search.home_address = obj['home_address']
      vm.search.home_tel = obj['home_tel']
      vm.search.school_name = obj['school_name']
      vm.watch.school_stage = obj['school_stage']
      vm.search.department = obj['department']
      vm.watch.old_grade = obj['old_grade']
      vm.watch.grade = obj['grade']
      vm.search.grade_flag = obj['grade_flag']
      vm.watch.department_type = obj['department_type']
      vm.search.club = obj['club']
      vm.watch.transportation_car = obj['transportation_car']
      vm.watch.transportation_bike = obj['transportation_bike']
      vm.watch.transportation_scooters = obj['transportation_scooters']
      vm.watch.transportation_bicycle = obj['transportation_bicycle']
      vm.watch.transportation_train = obj['transportation_train']
      vm.watch.transportation_none = obj['transportation_none']
      vm.search.nearest_station = obj['nearest_station']
      vm.search.high_school_name = obj['high_school_name']
      vm.search.high_school_club = obj['high_school_club']
      vm.watch.exam_s = obj['exam_s']
      vm.watch.exam_c = obj['exam_c']
      vm.watch.exam_k = obj['exam_k']
      vm.watch.exam_d = obj['exam_d']
      vm.watch.experience_tutor = obj['experience_tutor']
      vm.search.experience_tutor_note = obj['experience_tutor_note']
      vm.watch.experience_cram = obj['experience_cram']
      vm.search.experience_cram_note = obj['experience_cram_note']
      vm.watch.experience_none = obj['experience_none']
      vm.watch.channel_id = obj['channel_id']
      vm.search.medium_note = obj['medium_note']
      vm.watch.published = obj['published']
      vm.watch.information = obj['information']
      vm.watch.impression = obj['impression']
      vm.search.impression_note = obj['impression_note']
      vm.watch.training = obj['training']
      vm.search.training_note = obj['training_note']
      vm.watch.ssk = obj['ssk']
      vm.search.note = obj['note']
      vm.search.created_at = obj['created_at']
      vm.search.updated_at = obj['updated_at']

      vm.search.not_id = obj['not_id']
      vm.watch.not_office_id = obj['not_office_id']
      vm.watch.not_user_id = obj['not_user_id']
      vm.watch.not_state = obj['not_state']
      vm.search.not_registration_date = obj['not_registration_date']
      vm.search.not_name = obj['not_name']
      vm.search.not_kana = obj['not_kana']
      vm.watch.not_gender = obj['not_gender']
      vm.search.not_birthday = obj['not_birthday']
      vm.search.not_age = obj['not_age']
      vm.search.not_zip = obj['not_zip']
      vm.watch.not_pref = obj['not_pref']
      vm.search.not_address = obj['not_address']
      vm.search.not_tel1 = obj['not_tel1']
      vm.search.not_tel2 = obj['not_tel2']
      vm.search.not_mail1 = obj['not_mail1']
      vm.search.not_mail2 = obj['not_mail2']
      vm.search.not_home_zip = obj['not_home_zip']
      vm.watch.not_home_pref = obj['not_home_pref']
      vm.search.not_home_address = obj['not_home_address']
      vm.search.not_home_tel = obj['not_home_tel']
      vm.search.not_school_name = obj['not_school_name']
      vm.watch.not_school_stage = obj['not_school_stage']
      vm.search.not_department = obj['not_department']
      vm.watch.not_old_grade = obj['not_old_grade']
      vm.watch.not_grade = obj['not_grade']
      vm.search.not_grade_flag = obj['not_grade_flag']
      vm.watch.not_department_type = obj['not_department_type']
      vm.search.not_club = obj['not_club']
      vm.watch.not_transportation_car = obj['not_transportation_car']
      vm.watch.not_transportation_bike = obj['not_transportation_bike']
      vm.watch.not_transportation_scooters = obj['not_transportation_scooters']
      vm.watch.not_transportation_bicycle = obj['not_transportation_bicycle']
      vm.watch.not_transportation_train = obj['not_transportation_train']
      vm.watch.not_transportation_none = obj['not_transportation_none']
      vm.search.not_nearest_station = obj['not_nearest_station']
      vm.search.not_high_school_name = obj['not_high_school_name']
      vm.search.not_high_school_club = obj['not_high_school_club']
      vm.watch.not_exam_s = obj['not_exam_s']
      vm.watch.not_exam_c = obj['not_exam_c']
      vm.watch.not_exam_k = obj['not_exam_k']
      vm.watch.not_exam_d = obj['not_exam_d']
      vm.watch.not_experience_tutor = obj['not_experience_tutor']
      vm.search.not_experience_tutor_note = obj['not_experience_tutor_note']
      vm.watch.not_experience_cram = obj['not_experience_cram']
      vm.search.not_experience_cram_note = obj['not_experience_cram_note']
      vm.watch.not_experience_none = obj['not_experience_none']
      vm.watch.not_channel_id = obj['not_channel_id']
      vm.search.not_medium_note = obj['not_medium_note']
      vm.watch.not_published = obj['not_published']
      vm.watch.not_information = obj['not_information']
      vm.watch.not_impression = obj['not_impression']
      vm.search.not_impression_note = obj['not_impression_note']
      vm.watch.not_training = obj['not_training']
      vm.search.not_training_note = obj['not_training_note']
      vm.watch.not_ssk = obj['not_ssk']
      vm.search.not_note = obj['not_note']
      vm.search.not_created_at = obj['not_created_at']
      vm.search.not_updated_at = obj['not_updated_at']

      // for (let i = 0; i < vm.columns.length; i++) {
      //   const column = 'column_' + vm.columns[i].code
      //   vm.columns[i].show = obj[column]
      // }

      vm.searchTable()
    })
  },

  beforeRouteLeave (to, from, next) {
    // alert('save')
    let arr = []
    let obj = {

      id: this.search.id,
      office_id: this.watch.office_id,
      user_id: this.watch.user_id,
      state: this.watch.state,
      registration_date: this.search.registration_date,
      name: this.search.name,
      kana: this.search.kana,
      gender: this.watch.gender,
      birthday: this.search.birthday,
      age: this.search.age,
      zip: this.search.zip,
      pref: this.watch.pref,
      address: this.search.address,
      tel1: this.search.tel1,
      tel2: this.search.tel2,
      mail1: this.search.mail1,
      mail2: this.search.mail2,
      home_zip: this.search.home_zip,
      home_pref: this.watch.home_pref,
      home_address: this.search.home_address,
      home_tel: this.search.home_tel,
      school_name: this.search.school_name,
      school_stage: this.watch.school_stage,
      department: this.search.department,
      old_grade: this.watch.old_grade,
      grade: this.watch.grade,
      grade_flag: this.search.grade_flag,
      department_type: this.watch.department_type,
      club: this.search.club,
      transportation_car: this.watch.transportation_car,
      transportation_bike: this.watch.transportation_bike,
      transportation_scooters: this.watch.transportation_scooters,
      transportation_bicycle: this.watch.transportation_bicycle,
      transportation_train: this.watch.transportation_train,
      transportation_none: this.watch.transportation_none,
      nearest_station: this.search.nearest_station,
      high_school_name: this.search.high_school_name,
      high_school_club: this.search.high_school_club,
      exam_s: this.watch.exam_s,
      exam_c: this.watch.exam_c,
      exam_k: this.watch.exam_k,
      exam_d: this.watch.exam_d,
      experience_tutor: this.watch.experience_tutor,
      experience_tutor_note: this.search.experience_tutor_note,
      experience_cram: this.watch.experience_cram,
      experience_cram_note: this.search.experience_cram_note,
      experience_none: this.watch.experience_none,
      channel_id: this.watch.channel_id,
      medium_note: this.search.medium_note,
      published: this.watch.published,
      information: this.watch.information,
      impression: this.watch.impression,
      impression_note: this.search.impression_note,
      note: this.search.note,
      created_at: this.search.created_at,
      updated_at: this.search.updated_at,

      not_id: this.search.not_id,
      not_office_id: this.watch.not_office_id,
      not_user_id: this.watch.not_user_id,
      not_state: { name: '指導不可', value: 2 },
      not_registration_date: this.search.not_registration_date,
      not_name: this.search.not_name,
      not_kana: this.search.not_kana,
      not_gender: this.watch.not_gender,
      not_birthday: this.search.not_birthday,
      not_age: this.search.not_age,
      not_zip: this.search.not_zip,
      not_pref: this.watch.not_pref,
      not_address: this.search.not_address,
      not_tel1: this.search.not_tel1,
      not_tel2: this.search.not_tel2,
      not_mail1: this.search.not_mail1,
      not_mail2: this.search.not_mail2,
      not_home_zip: this.search.not_home_zip,
      not_home_pref: this.watch.not_home_pref,
      not_home_address: this.search.not_home_address,
      not_home_tel: this.search.not_home_tel,
      not_school_name: this.search.not_school_name,
      not_school_stage: this.watch.not_school_stage,
      not_department: this.search.not_department,
      not_old_grade: this.watch.not_old_grade,
      not_grade: this.watch.not_grade,
      not_grade_flag: this.search.not_grade_flag,
      not_department_type: this.watch.not_department_type,
      not_club: this.search.not_club,
      not_transportation_car: this.watch.not_transportation_car,
      not_transportation_bike: this.watch.not_transportation_bike,
      not_transportation_scooters: this.watch.not_transportation_scooters,
      not_transportation_bicycle: this.watch.not_transportation_bicycle,
      not_transportation_train: this.watch.not_transportation_train,
      not_transportation_none: this.watch.not_transportation_none,
      not_nearest_station: this.search.not_nearest_station,
      not_high_school_name: this.search.not_high_school_name,
      not_high_school_club: this.search.not_high_school_club,
      not_exam_s: this.watch.not_exam_s,
      not_exam_c: this.watch.not_exam_c,
      not_exam_k: this.watch.not_exam_k,
      not_exam_d: this.watch.not_exam_d,
      not_experience_tutor: this.watch.not_experience_tutor,
      not_experience_tutor_note: this.search.not_experience_tutor_note,
      not_experience_cram: this.watch.not_experience_cram,
      not_experience_cram_note: this.search.not_experience_cram_note,
      not_experience_none: this.watch.not_experience_none,
      not_channel_id: this.watch.not_channel_id,
      not_medium_note: this.search.not_medium_note,
      not_published: this.watch.not_published,
      not_information: this.watch.not_information,
      not_impression: this.watch.not_impression,
      not_impression_note: this.search.not_impression_note,
      not_training: this.watch.not_training,
      not_training_note: this.search.not_training_note,
      not_ssk: this.watch.not_ssk,
      not_note: this.search.not_note,
      not_created_at: this.search.not_created_at,
      not_updated_at: this.search.not_updated_at
    }

    // for (let i = 0; i < this.columns.length; i++) {
    //   const column = 'column_' + this.columns[i].code
    //   obj[column] = this.columns[i].show
    // }

    arr.push(obj)
    let setjson = JSON.stringify(obj)
    localStorage.setItem('Tutors2Search', setjson)
    next()
  }
}
</script>

<style lang="scss" scoped>
/* .splitpanes__pane { */
/*   justify-content: center; */
/*   align-items: center; */
/*   display: flex; */
/* } */

/* .splitpanes__pane span { */
/*   font-family: Helvetica, Arial, sans-serif; */
/*   color: #fff; */
/*   font-size: 5em; */
/*   opacity: 0.6; */
/* } */
</style>

<style lang="scss" scoped>
/* .sticky-1 { */
/*   position: sticky; */
/*   top: 0; */
/*   background: #fff; */
/*   &:before { */
/*     content: ''; */
/*     position: absolute; */
/*     display: block; */
/*     background: #ccc; */
/*     height: 1px; */
/*     width: 100%; */
/*     left: 0; */
/*     top: -1px; */
/*   } */
/* } */
/* .sticky-2 { */
/*   position: sticky; */
/*   top: 24px; */
/*   background: #fff; */
/*   &:before { */
/*     content: ''; */
/*     position: absolute; */
/*     display: block; */
/*     background: #ccc; */
/*     height: 1px; */
/*     width: 100%; */
/*     left: 0; */
/*     top: -1px; */
/*   } */
/* } */
/* .sticky-3 { */
/*   position: sticky; */
/*   top: 49px; */
/*   &:before { */
/*     content: ''; */
/*     position: absolute; */
/*     display: block; */
/*     background: #ccc; */
/*     height: 1px; */
/*     width: 100%; */
/*     left: 0; */
/*     top: -1px; */
/*   } */
/*   &:after { */
/*     content: ''; */
/*     position: absolute; */
/*     display: block; */
/*     background: #ccc; */
/*     height: 1px; */
/*     width: 100%; */
/*     left: 0; */
/*     bottom: -1px; */
/*   } */
/* } */
.m-label-custom {
  cursor: pointer;
  margin-bottom: 1px;
}
.slideActive {
  background: #455A64;
  color: #fff;
}
.active {
  background: #455A64;
  border: solid 1px #455A64;
  color: #fff;
}
.resetSearch {
  padding: 7px 0;
}
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
.select {
  padding: 0 !important;
}
input {
  width: 100%;
  min-width: 100px;
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
}
.index-box {
  height: calc(100vh - 220px);
  overflow: scroll;
  margin-top: 10px;
  &:after {
    content: "\f19d";
    font-family: FontAwesome;
    position: absolute;
    font-size: 300px;
    top: 50%;
    left: 50%;
    margin-top: -150px;
    margin-left: -150px;
    color: #ddd;
    opacity: 0.1;
    z-index: -1;
  }
}

.export-modal {
  position: absolute;
  top: 0px;
  right: 0px;
}

.pager {
  padding-bottom: 5px;
}
.nowIndex {
  position: relative;
  padding: 0px 10px;
  top: -1px;
}
.fa-arrow-left, .fa-arrow-right {
  font-size: 20px;
  color: #334750;
}
.now {
  background: #41B883;
  color: #fff;
}
.men {
  color: #3F51B5;
}
.women {
  color: #E91E63;
}
</style>

<style lang="scss">
.TutorsIndex2 {
  .multiselect {
    min-height: 23px;
    min-width: 100px;
  }
  .multiselect__tag {
    margin: 1px;
    font-size: 10px;
  }
  .multiselect__tag-icon {
    line-height: 18px;
    &:after {
      font-size: 10px;
    }
  }
  .multiselect__tags {
    border: solid 1px #ccc;
    min-height: 23px;
    padding: 0px 23px 0 2px;
    border-radius: 0;
    border: none;
    margin: 3px 1px 1px 1px;
  }
  .multiselect__tags-wrap {
    /* background: red; */
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 23px;
  }
  .multiselect__select {
    height: 23px;
    width: 26px;
    top: 2px;
    padding: 0;
    &:before {
      top: 65%;
    }
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// TutorsIndex2.vue?61bd9f99